// ⚠️⚠️⚠️ Disclaimer: Please tailor this content to suit the specific needs of your business.

import React from "react";
import { IconBook, IconCertificate } from "@tabler/icons-react";
import { SpotlightActionData } from "@mantine/spotlight";
import { navigate } from "vike/client/router";

async function onSubmit(route: string) {
  const navigationPromise = navigate(route);
  await navigationPromise;
}

export const glossary: readonly SpotlightActionData[] = Object.freeze([
  {
    id: "Opquast - Making the Web bettere",
    label: "Opquast - Making the Web better",
    description:
      "Opquast is a non-profit organization that creates and promotes checklists for web quality, trains and certifies web professionals, and fosters a community of web quality advocates. Learn about Opquast's missions, rules, news,...",
    onClick: () => window.open("https://www.opquast.com/en/", "_blank", "noopener,noreferrer"),
    leftSection: <IconCertificate aria-label="Opens an external website in a new tab" size={24} stroke={1.5} />,
  },
  {
    id: "browser-cache",
    label: "Browser Cache",
    description:
      "Functionality of web browsers to locally conserve a resource record of a web page (image, file CSS, JavaScript files, etc.) to avoid having to download it again when visited the next time. The duration of use of a cache resource depends on metadata associated with it.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "path-of-steps",
    label: "Path of Steps",
    description:
      "In a complex process, the steps path shows the user the list step of the process and allows you to specify at what stage it is.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "vignette",
    label: "Vignette",
    description:
      "Reduced version of content (usually an image, but also a video, etc.) displayed as an image-link to the actual content, or illustration of a link to it.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "ol-html-tag",
    label: "ol (HTML tag)",
    description:
      "HTML tag for marking an ordered list (typically, a numbered list) .The other HTML list items are the ul (unordered lists) and dl (lists description).",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "apache",
    label: "Apache",
    description: "Free web server software.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "id",
    label: "ID",
    description:
      "The HTML id attribute is used to specify a unique id for an HTML element. You cannot have more than one element with the same id in an HTML document.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "gif",
    label: "GIF",
    description:
      "Digital image format for generating a compressed version of a still or moving image (by combining several successive images into a single file), limited to a maximum of 256 colors, with or without transparency. In websites, its use is particularly suitable for logos, icons, graphics, and other non-photographic images.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "disable-styles",
    label: "Disable Styles",
    description:
      "Rendering the web page without the CSS styles that determine its layout: only the default styles of the browser are applied to the content. Rendering with styles disabled gives an idea of what is used by a user agent other than the browser: for example, an indexing robot or a screen reader. It reveals the possible loss of information due to the presence of CSS-generated content.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "quick-link",
    label: "Quick Link",
    description:
      "Link placed at the beginning of the page content, allowing, during keyboard navigation, quick access to the content, menu or search areas without having to go through all the links and other interaction elements that precede it.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "graphic-mockup",
    label: "Graphic Mockup",
    description:
      "Elaboration of the design of the final and complete aspect of a web page (colors, typography, visual effects, etc.) that will serve as a basis for HTML integration.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "chart",
    label: "Chart",
    description: "Graphical representation of data: diagrams, pie charts, curves, etc.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "limited-access-content",
    label: "Limited Access Content",
    description:
      "A set of web pages or content whose access requires authentication and is reserved for one or more users.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "ui",
    label: "UI (User Interface)",
    description:
      "The UI (user interface) is the perceptible part of a product, linking the human and the machine. In the case of the website: what the user will see, read, click, touch (touch screen) etc.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "keyboard-navigation",
    label: "Keyboard Navigation",
    description:
      "A user may, for various reasons or constraints, not use the mouse or other similar pointing device. They can then interact with the Web browser and the pages consulted using only the keyboard.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "aggregator",
    label: "Aggregator",
    description:
      "A Web aggregator or content aggregator is a software or server feature that exploits RSS feeds to retrieve, exploit or render information published in the form of syndication feeds from websites.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "character-encoding",
    label: "Character Encoding",
    description: "See Unicode.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "indicated",
    label: "Indicated",
    description:
      "According to Opquast’s good quality practices, a content “indicated” in the page is a content that is present and can be consulted directly in the page (on the other hand, a content that can be accessed via a link present in the page is said to be “available”).",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "design-phase",
    label: "Design (Phase)",
    description:
      "In the Opquast approach, the “design” phase of the design process of a site or a Web service is the one that brings together the initial stages, linked to the specifications, prototyping, functional modeling and graphic modeling, upstream of the two other main phases, those of development and then editorial.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "coq",
    label: "COQ (Cost of Obtaining Quality)",
    description:
      "The COQ (Cost of Obtaining Quality) are production costs and prevention needed to maintain the quality of the site or Service.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "infinite-scrolling",
    label: "Infinite Scrolling",
    description:
      "A technique for loading content that allows it to be downloaded and displayed as the user scrolls through the web page.",
    onClick: () => onSubmit("/glossary"),
    leftSection: <IconBook aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
]);
